import { render, staticRenderFns } from "./token-details.vue?vue&type=template&id=18de47b0&scoped=true&"
import script from "./token-details.vue?vue&type=script&lang=js&"
export * from "./token-details.vue?vue&type=script&lang=js&"
import style0 from "./token-details.vue?vue&type=style&index=0&id=18de47b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de47b0",
  null
  
)

export default component.exports